<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header" style="display: flex; align-items: center; justify-content: space-between;">
        <h3>Deadlines</h3>
        <div style="display: flex; align-items: center;">
            <div [hidden]="editMode && isStatePage" style="display: flex; align-items: center;">
                <span>Tax Year:</span>
                <select class="form-select form-select-sm all"
                        style="width: auto !important; margin-left: 5px;"
                        [disabled]="serverAction"
                        (change)="yearChanged()"
                        [(ngModel)]="selectedYear">
                    @for (year of years; track year) {
                        <option [ngValue]="year">{{ year }}</option>
                    }
                </select>
            </div>
            <div class="header-button-container">
                @if (!editMode) {
                    <button class="ace-btn btn-text has-icon btn-primary mb-0"
                            [hidden]="!hasEditPermission"
                            (click)="edit()"
                            [disabled]="serverAction"
                            [hidden]="!hasEditPermission">
                        <i class="fa fa-pencil"></i>
                    </button>
                }
                @if (editMode) {
                    <span>
            <button class="ace-btn btn-text has-icon btn-primary btn-success mb-0" [disabled]="serverAction" (click)="save()">
              <i class="fa fa-save"></i>
            </button>
            <button class="ace-btn btn-text has-icon btn-primary btn-danger mb-0" [disabled]="serverAction" (click)="cancel()">
              <i class="fa fa-close"></i>
            </button>
          </span>
                }
            </div>
        </div>
    </div>
    <div class="panel-flat-body">
        <ws-ace-loader [show]="serverAction" [size]="4" [hasOverlay]="true"></ws-ace-loader>
        @if (editMode) {
            <div style="margin-bottom: 20px;">
                <ws-select placeholder="Add Deadline"
                           [(ngModel)]="chosenDeadlineProptype"
                           (selectedOptionChanged)="addDeadline()"
                           [options]="unassignedDeadlinePropTypes"
                           labelProperty="display"
                           [returnEntireOption]="true">
                </ws-select>
            </div>
        }
        <table class="deadline-table">
            <tbody>
                @for (deadlineType of deadlinesByDeadlineType; track deadlineType) {
                    @if (deadlineType.deadlines.length) {
                        <tr>
                            <td colspan="4" class="deadline-type-heading">
                                @if (deadlineType.appealDeadlineTypeID > 0) {
                                    <h4>{{ deadlineType.deadlineType }} Deadlines @if ((!isStatePage) && editMode) {
                                        <span>(Assessor Overrides)</span>
                                    }</h4>
                                }
                                @if (deadlineType.appealDeadlineTypeID < 0) {
                                    <h4>{{ deadlineType.deadlineType }}</h4>
                                }
                            </td>
                        </tr>
                        @for (deadline of deadlineType.deadlines; track deadline) {
                            @if (deadline.efAction !== 'delete') {
                                @if (!editMode) {
                                    <tr>
                                        <td>
                                            <span
                                                helpTooltip
                                                [hasIcon]="showTooltipIcon(deadline.appealDeadlineTypeID)"
                                                [tooltipText]="getHelpTooltip(deadline.appealDeadlineTypeID)">
                                                    {{ deadline.propertyTypeName }}
                                            </span>
                                        </td>
                                        <td>
                                            @if (deadline.deadlineYearID !== null) {
                                                <span>{{ getDeadlineDateStr(deadline) }}</span>
                                            }
                                            @if (deadline.deadlineYearID === null) {
                                                <span>{{ deadline.deadlineDate | date:'M/d/yyyy':'utc' }}</span>
                                            }
                                            @if (deadline.earliestPossible) {
                                                <span>^</span>
                                            }
                                        </td>
                                        <td>
                                            @if (isStatePage && deadlineHasExceptions(deadline)) {
                                                <a class="pointer"
                                                   (click)="openAssessorExceptions(deadline)"
                                                   title="Click to see the list of assessors where deadline varies">
                                                    (Exceptions)
                                                </a>
                                            }
                                            @if (!isStatePage && deadline.entityID != assessorId) {
                                                <a
                                                    anchor-route
                                                    [sref]="{ target: 'state', options: { stateId: stateId } }"
                                                    title="Deadline taken from the state setups.  There is no specific deadline set for this assessor.">
                                                    (per state setup)
                                                </a>
                                            }
                                        </td>
                                        <td></td>
                                    </tr>
                                }
                                @if (editMode) {
                                    <tr>
                                        <td style="white-space: nowrap;">{{ deadline.propertyTypeName }}</td>
                                        <td>
                                            @if (deadline.deadlineYearID != null) {
                                                <div style="display: flex;">
                                                    <input type="text"
                                                           [required]="deadline.deadlineYearID != null"
                                                           class="form-control sd-validate-input-text"
                                                           [(ngModel)]="deadline.deadlineMonthDay"
                                                           (ngModelChange)="setDirty(deadline)"
                                                           style="width:60px;">
                                                    <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="deadline.deadlineYearID" (change)="setDirty(deadline)">
                                                        @for (type of YEAR_TYPES; track type) {
                                                            <option [ngValue]="type.id">{{ type.name }}</option>
                                                        }
                                                    </select>
                                                </div>
                                            }
                                            @if (deadline.deadlineYearID == null) {
                                                <weissman-datetime
                                                    [(inputDate)]="deadline.deadlineDate"
                                                    [dateOnly]="true"
                                                    (inputDateChange)="setDirty(deadline)"
                                                    [required]="true">
                                                </weissman-datetime>
                                            }
                                        </td>
                                        <td>
                                            @if (deadlineType.appealDeadlineTypeID > 0) {
                                                <div class="checkbox">
                                                    <label style="white-space: nowrap;">
                                                        <input type="checkbox" [(ngModel)]="deadline.earliestPossible" (change)="setDirty(deadline)">
                                                        Earliest Possible
                                                    </label>
                                                </div>
                                            }
                                        </td>
                                        <td>
                                            @if (deadlineType.appealDeadlineTypeID > 0) {
                                                <button class="ace-btn has-icon btn-primary btn-danger" (click)="delete(deadline)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                }
                                @if (deadline.efAction && !deadline.earliestPossible && deadlineType.appealDeadlineTypeID > 0) {
                                    <tr class="from-date">
                                        <td>From Date:</td>
                                        <td>
                                            <weissman-datetime [(inputDate)]="deadline.fromDate" [dateOnly]="true"></weissman-datetime>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                }
                            }
                        }
                    }
                }
            </tbody>
        </table>

        @if (checkUseEarliestPossible) {
            <div style="margin-top: 20px;">
                <span>^Not available. Projected as earliest possible date.</span>
            </div>
        }
    </div>
</div>
